<template>
    <Mikomi_Type_Other v-for="keikaku in MikomiMonthData.Keikaku" :key="keikaku" :Month="MikomiMonthData.Month" :Team="Team" :MikomiTypeData="keikaku.Data" :CellTitlePrefix="KeikakuCellTitlePrefix(keikaku)" :CellColor="KeikakuCellColor(keikaku)" />
    <template v-if="ShowEstimation()">
        <Mikomi_Type_Other :Team="Team" :MikomiTypeData="MikomiMonthData.Estimation" :Month="MikomiMonthData.Month" :IsEstimation="true" :CellTitlePrefix="'見込 '" :CellColor="'#DAEEF3'" />
    </template>
    <template v-else>
        <Mikomi_Type_Other :Team="Team" :MikomiTypeData="MikomiMonthData.Result" :Month="MikomiMonthData.Month" :IsResult="true" :CellTitlePrefix="'実績 '" :CellColor="'#DAEEF3'" />
    </template>
    <Mikomi_Type_Other :Team="Team" :MikomiTypeData="MikomiMonthData.Difference" :Month="MikomiMonthData.Month" :IsDifference="true" :CellTitlePrefix="'差額 '" :CellColor="'#FFFFFF'" />
    <div style="margin-right: 1px;"></div>
</template>

<script>
import Mikomi_Type_Other from './Mikomi_Type_Other.vue';
export default{
    components:{
        Mikomi_Type_Other,
    },
    props:{
        MikomiMonthData: Object,
        CurrentMonth: Number,
        Team: String,
    },
    methods:{
        KeikakuCellTitlePrefix(keikaku)
        {
            switch(keikaku.Revision)
            {
                case 0: return '計画 ';
                case 1: return '3月見直計画 ';
                case 2: return '6月見直計画 ';
                case 3: return '9月見直計画 ';
                default: return '';
            } 
        },
        KeikakuCellColor(keikaku)
        {
            switch(keikaku.Revision)
            {
                case 0: return '#D8E4BC';
                case 1: return '#FDE9D9';
                case 2: return '#E4DFEC';
                case 3: return '#FFFF99';

                default: '#FF9900';
            } 
        },
        ShowEstimation()
        {
            if (this.MikomiMonthData.IsQuarter === false &&
                this.MikomiMonthData.IsHalfYear === false)
            {
                return this.MikomiMonthData.Month >= this.CurrentMonth;
            }
            else if (this.MikomiMonthData.IsQuarter === true)
            {
                switch(this.MikomiMonthData.Quarter)
                {
                    case 1: return this.CurrentMonth <= 3;
                    case 2: return this.CurrentMonth <= 6;
                    case 3: return this.CurrentMonth <= 9;
                    case 4: return this.CurrentMonth <= 12;
                    default: return true;
                }
            }
            else if (this.MikomiMonthData.IsHalfYear === true)
            {
                switch(this.MikomiMonthData.Quarter)
                {
                    case 1: return this.CurrentMonth <= 6;
                    case 2: return this.CurrentMonth <= 12;
                    default: return true;
                }
            }
        }
    },
    // mounted(){
    //     console.log(`[Mikomi_Month_Other] ${this.Team} ${this.MikomiMonthData.Month}月`, this.MikomiMonthData);
    // }
}
</script>